export default __webpack_public_path__ + "images/664fc53df42206d4c260fc5d751f067e-climbing.jpg";